import { Modal, modalWidth } from "@hubrise/react-components"
import * as React from "react"

import { ToolButton } from "Catalog/shared/components/CatalogToolbar"

import ModalContent from "./ModalContent"

interface NewButtonProps {
  handleCreate: (name: string) => void
  labelAndTitle: string
  disabled?: boolean
}

const NewButton = ({ handleCreate, labelAndTitle, disabled = false }: NewButtonProps): JSX.Element => {
  return (
    <Modal
      modalWidth={modalWidth.small}
      renderLink={({ open }) => (
        <ToolButton icon="add" onClick={open} disabled={disabled}>
          {labelAndTitle}
        </ToolButton>
      )}
      renderContent={({ close }) => <ModalContent onClose={close} handleCreate={handleCreate} title={labelAndTitle} />}
    />
  )
}

export default NewButton
